import styled from 'styled-components';
import { Text } from '@sparknz/spark-pattern-library';

export const StyledAvailabilityText = styled(Text)`
  color: ${({ theme: { palette } }) => `${palette.baseColors.mawhero}`};
`;
